export const SHOW_ADD_PRODUCT_HINWEIS_KEY = "sbe.merkzettel.showAddProductHinweis";
export const SHOW_CREATE_LIST_HINWEIS_KEY = "sbe.merkzettel.showCreateListHinweis";
export const SHOW_DELETE_LIST_HINWEIS_KEY = "sbe.merkzettel.showDeleteListHinweis";
export const SHOW_RENAME_LIST_HINWEIS_KEY = "sbe.merkzettel.showRenameListHinweis";

export const MERKZETTEL_NOTOFICATION_AFTER_RELOAD_KEY = "sbe.merkzettel.showNotificationAfterReload";

export function setNotificationAfterReload(key) {
    localStorage.setItem(MERKZETTEL_NOTOFICATION_AFTER_RELOAD_KEY, key);
}